import { DotsIcon } from 'asterX-UIkit/Icons/DotsIcon'
import { KeyIcon } from 'asterX-UIkit/Icons/KeyIcon'
import { LockIcon } from 'asterX-UIkit/Icons/LockIcon'
import { MonitorIcon } from 'asterX-UIkit/Icons/MonitorIcon'
import { OneCIcon } from 'asterX-UIkit/Icons/OneCIcon'
import { PlusIcon } from 'asterX-UIkit/Icons/PlusIcon'
import { VideoCameraIcon } from 'asterX-UIkit/Icons/VideoCameraIcon'
import { WifiIcon } from 'asterX-UIkit/Icons/WifiIcon'

import * as division from 'constants/divisions'
import { CoinsHandIcon } from '../../../../asterX-UIkit/Icons'

export const moduleList = [
  {
    icon: KeyIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Доступы'
  },
  {
    icon: MonitorIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Программное обеспечение и устройства'
  },
  {
    icon: PlusIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Запрос на технику'
  },
  {
    icon: WifiIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Сеть, интернет и телефония'
  },
  {
    icon: LockIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'BS'
  },
  {
    icon: OneCIcon,
    division: division.HELP_DESK_DIVISION,
    module: '1С'
  },
  {
    icon: VideoCameraIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Видеонаблюдение'
  },
  {
    icon: DotsIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Прочее'
  },
  {
    icon: CoinsHandIcon,
    division: division.HELP_DESK_DIVISION,
    module: 'Кредитный конвейер'
  }
]
